export const GET_CITIES = "GET_CITIES";
export const GET_CITIES_SUCCESS = "GET_CITIES_SUCCESS";
export const GET_CITIES_ERROR = "GET_CITIES_ERROR";

export const ADD_CITY = "ADD_CITY";
export const ADD_CITY_SUCCESS = "ADD_CITY_SUCCESS";
export const ADD_CITY_ERROR = "ADD_CITY_ERROR";

export const GET_CITY = "GET_CITY";
export const GET_CITY_SUCCESS = "GET_CITY_SUCCESS";
export const GET_CITY_ERROR = "GET_CITY_ERROR";

export const UPDATE_CITY = "UPDATE_CITY";
export const UPDATE_CITY_SUCCESS = "UPDATE_CITY_SUCCESS";
export const UPDATE_CITY_ERROR = "UPDATE_CITY_ERROR";

export const DELETE_CITY = "DELETE_CITY";
export const DELETE_CITY_SUCCESS = "DELETE_CITY_SUCCESS";
export const DELETE_CITY_ERROR = "DELETE_CITY_ERROR";

export const UPLOAD_CITY_ICON = "UPLOAD_CITY_ICON";
export const UPLOAD_CITY_ICON_SUCCESS = "UPLOAD_CITY_ICON_SUCCESS";
export const UPLOAD_CITY_ICON_ERROR = "UPLOAD_CITY_ICON_ERROR";

export const TOGGLE_CITY_MODAL = "TOGGLE_CITY_MODAL";
